// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var Clipboard$SmartcutsMacros = require("./Clipboard.bs.js");
var DOM__Blob$SmartcutsMacros = require("./DOM__Blob.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var Webapi__FileReader$SmartcutsMacros = require("./Webapi/Webapi__FileReader.bs.js");
var Navigator__Clipboard$SmartcutsMacros = require("./Navigator/Navigator__Clipboard.bs.js");

function textOrImageResolved_encode(v) {
  if (v.TAG === /* TextResolved */0) {
    return [
            "TextResolved",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "ImageResolved",
            Clipboard$SmartcutsMacros.imageResolved_encode(v._0),
            Image$SmartcutsMacros.Metadata.t_encode(v._1)
          ];
  }
}

function textOrImageResolved_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ImageResolved" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Clipboard$SmartcutsMacros.imageResolved_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ImageResolved */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "TextResolved" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TextResolved */0,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringifyTextOrImageResolved(textOrImageResolved) {
  if (textOrImageResolved.TAG === /* TextResolved */0) {
    return "TextResolved(" + (textOrImageResolved._0 + ")");
  } else {
    return "ImageResolved(" + (Clipboard$SmartcutsMacros.stringifyImageResolved(textOrImageResolved._0) + (", " + (Image$SmartcutsMacros.Metadata.stringify(textOrImageResolved._1) + ")")));
  }
}

function copyTextToClipboardUsingTextAreaHack(str) {
  var htmlDocument = document;
  var selection = htmlDocument.getSelection();
  var maybeSelected = selection.rangeCount > 0 ? Caml_option.some(htmlDocument.getSelection().getRangeAt(0)) : undefined;
  var injectElement = function (param) {
    var textarea = document.createElement("textarea");
    textarea.value = str;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "absolute";
    textarea.style.position = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    return Promise.resolve(textarea);
  };
  return injectElement(undefined).then(function (elementInjected) {
              console.warn("elementInjected", elementInjected);
              document.execCommand("copy");
              document.body.removeChild(elementInjected);
              if (maybeSelected !== undefined) {
                htmlDocument.getSelection().removeAllRanges();
                htmlDocument.getSelection().addRange(Caml_option.valFromOption(maybeSelected));
                return Promise.resolve(undefined);
              } else {
                return Promise.resolve(undefined);
              }
            });
}

function copyImageResolvedToClipboard(format, imageResolved) {
  var blobPromise;
  if (imageResolved.TAG === /* Base64Encoded */0) {
    var dataURI = "data:" + (Image$SmartcutsMacros.Format.mimeType(format) + (";base64," + imageResolved._0));
    blobPromise = Promise.resolve(new Blob([DOM__Blob$SmartcutsMacros.dataURIToBinary(dataURI)], {
              type: Image$SmartcutsMacros.Format.mimeType(format)
            }));
  } else {
    blobPromise = fetch(imageResolved._0).then(function (prim) {
          return prim.blob();
        });
  }
  return blobPromise.then(function (blob) {
              var clipboardItem = Navigator__Clipboard$SmartcutsMacros.ClipboardItem.make(undefined, Belt_MapString.fromArray([[
                          Image$SmartcutsMacros.Format.mimeType(format),
                          {
                            TAG: /* Blob */0,
                            _0: blob
                          }
                        ]]));
              return Navigator__Clipboard$SmartcutsMacros.write([clipboardItem]);
            });
}

function copyImageResolvedUsingContentEditableHack(format, width, height, imageResolved) {
  var htmlDocument = document;
  var selection = htmlDocument.getSelection();
  var maybeSelected = selection.rangeCount > 0 ? Caml_option.some(htmlDocument.getSelection().getRangeAt(0)) : undefined;
  var injectElement = function (param) {
    var container = document.createElement("div");
    var resolveAsDataURL = function (param) {
      if (imageResolved.TAG === /* Base64Encoded */0) {
        return Promise.resolve("data:" + (Image$SmartcutsMacros.Format.mimeType(format) + (";base64," + imageResolved._0)));
      } else {
        return fetch(imageResolved._0).then(function (prim) {
                        return prim.blob();
                      }).then(function (blob) {
                      var fileReader = Webapi__FileReader$SmartcutsMacros.make(undefined);
                      return Webapi__FileReader$SmartcutsMacros.readAsDataUrlPromise(fileReader, blob);
                    }).then(function (result_maybeDataUrl) {
                    if (result_maybeDataUrl.TAG === /* Ok */0) {
                      return Promise.resolve(OptionUtils$SmartcutsMacros.getExn("Expect dataUrl", result_maybeDataUrl._0));
                    }
                    var error = result_maybeDataUrl._0;
                    if (error) {
                      console.error("FileReader did error while reading blob: ", error._0);
                      return Util$SmartcutsMacros.logAndRaiseJsError("FileReader did error while reading blob");
                    } else {
                      return Util$SmartcutsMacros.logAndRaiseJsError("FileReader did abort while reading blob");
                    }
                  });
      }
    };
    var func = Image$SmartcutsMacros.HtmlImage.make;
    var arg = width;
    var arg$1 = height;
    return resolveAsDataURL(undefined).then(function (eta) {
                  return Curry._4(func, undefined, arg, arg$1, eta);
                }).then(function (image) {
                container.appendChild(image);
                container.setAttribute("contenteditable", "");
                document.body.appendChild(container);
                container.style.position = "absolute";
                container.style.position = "-9999px";
                selection.removeAllRanges();
                var range = new Range();
                range.setStartBefore(image);
                range.setEndAfter(image);
                range.selectNode(image);
                selection.addRange(range);
                console.warn("selection", selection);
                return Promise.resolve(container);
              });
  };
  return injectElement(undefined).then(function (elementInjected) {
              console.warn("elementInjected", elementInjected);
              document.execCommand("copy");
              document.body.removeChild(elementInjected);
              if (maybeSelected !== undefined) {
                htmlDocument.getSelection().removeAllRanges();
                htmlDocument.getSelection().addRange(Caml_option.valFromOption(maybeSelected));
                return Promise.resolve(undefined);
              } else {
                return Promise.resolve(undefined);
              }
            });
}

function copyToClipboard(textOrImageResolved) {
  if (textOrImageResolved.TAG === /* TextResolved */0) {
    return copyTextToClipboardUsingTextAreaHack(textOrImageResolved._0);
  }
  var match = textOrImageResolved._1;
  return copyImageResolvedUsingContentEditableHack(match.format, match.width, match.height, textOrImageResolved._0);
}

function readFromClipboard(param) {
  var textarea = document.createElement("textarea");
  textarea.style.position = "absolute";
  textarea.style.position = "-9999px";
  document.body.appendChild(textarea);
  var htmlDocument = document;
  var maybeSelected = htmlDocument.getSelection().rangeCount > 0 ? Caml_option.some(htmlDocument.getSelection().getRangeAt(0)) : undefined;
  console.warn("maybeSelected", maybeSelected);
  textarea.select();
  document.execCommand("paste");
  textarea.select();
  var pastedValue = textarea.value;
  console.warn("pastedValue", pastedValue);
  document.body.removeChild(textarea);
  if (maybeSelected !== undefined) {
    htmlDocument.getSelection().removeAllRanges();
    htmlDocument.getSelection().addRange(Caml_option.valFromOption(maybeSelected));
  }
  return Promise.resolve(pastedValue);
}

exports.textOrImageResolved_encode = textOrImageResolved_encode;
exports.textOrImageResolved_decode = textOrImageResolved_decode;
exports.stringifyTextOrImageResolved = stringifyTextOrImageResolved;
exports.copyTextToClipboardUsingTextAreaHack = copyTextToClipboardUsingTextAreaHack;
exports.copyImageResolvedToClipboard = copyImageResolvedToClipboard;
exports.copyImageResolvedUsingContentEditableHack = copyImageResolvedUsingContentEditableHack;
exports.copyToClipboard = copyToClipboard;
exports.readFromClipboard = readFromClipboard;
/* Util-SmartcutsMacros Not a pure module */
